module.exports = __webpack_public_path__ + "web/img/avatar.33bdd23d.png";